export enum TextTokenType {
  Xs3 = 'text-3xs',
  Xs2 = 'text-2xs',
  Xs = 'text-xs',
  Sm = 'text-sm',
  Base = 'text-base',
  Lg = 'text-lg',
  Xl = 'text-xl',
  Xl2 = 'text-2xl',
  Xl3 = 'text-3xl',
  Xl4 = 'text-4xl',
  Xl5 = 'text-5xl',
  Xl6 = 'text-6xl',
  Xl7 = 'text-7xl',
}
